"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFormatTextInput = void 0;
const react_number_format_1 = require("react-number-format");
const react_1 = __importDefault(require("react"));
const TextInput_1 = require("../TextInput/TextInput");
const CurrencyFormatTextInput = (props) => {
    return (react_1.default.createElement(TextInput_1.TextInput, { disabled: props.disabled, style: props.style, value: props.value, label: props.label, error: props.error, className: props.className, variant: props.variant, startIcon: props.startIcon, endIcon: props.endIcon, helperText: props.helperText, inputComponent: react_1.default.createElement(react_number_format_1.NumericFormat, Object.assign({ id: "input", className: `form__field`, onValueChange: (values) => props.onChange &&
                props.onChange({
                    target: {
                        value: values.value,
                    },
                }), onFocus: props.onFocus, onBlur: props.onBlur, decimalScale: 2, allowNegative: props.allowNegative, thousandSeparator: true, prefix: "$", value: props.value, placeholder: props.label, disabled: props.disabled }, props === null || props === void 0 ? void 0 : props.numberFormatProps)) }));
};
exports.CurrencyFormatTextInput = CurrencyFormatTextInput;
exports.CurrencyFormatTextInput.displayName = 'CurrencyFormatTextInput';
//# sourceMappingURL=CurrencyFormatTextInput.js.map